"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveCurrencyCode2LocalStorage = exports.getCurrencyCodeFromLocalStorage = void 0;
var _localStorageInterface = _interopRequireDefault(require("../../helpers/localStorageInterface"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var KEY = '__TS_SAVED_USER_CURRENCY_CODE__';
var getCurrencyCodeFromLocalStorage = exports.getCurrencyCodeFromLocalStorage = function getCurrencyCodeFromLocalStorage() {
  return _localStorageInterface.default.getItem(KEY);
};
var saveCurrencyCode2LocalStorage = exports.saveCurrencyCode2LocalStorage = function saveCurrencyCode2LocalStorage(currencyCode) {
  return _localStorageInterface.default.setItem(KEY, currencyCode);
};